<template>
  <div  :style="{height:height+'px'}" class="bg audit-home">
    <!-- <TabBar :datas="bars"/> -->
    <router-view style="overflow-y: auto;height:100%;" v-if="show"/>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import TabBar from '@/components/TabBar'
import VueRouter from 'vue-router'
export default {
  name: "AppHome",
  components:{
    TabBar
  },
  data() {
    return {
      show:true,
      bars:[],
      height:window.innerHeight
    }
  },
  created(){
    document.title='首页'
    console.log('高度:',this.height)
    // window.addEventListener('resize',(e)=>{
    //   debugger
    // })

    // window.onzoom=function(e){
    //   debugger
    // }
  },
  methods:{
    reload(){
      this.show = false
      this.show = true
    }
  }
};
</script>

<style lang="less">
@import '../assets/styles/theme.less';
</style>
<style>

.van-cell--center .van-cell__value--alone{
  text-align: center !important;
}
.van-field__body input{
  overflow: hidden;
  text-overflow: ellipsis;
}

pre{
    font-family: Avenir, Helvetica, Arial, sans-serif !important;
    color:#323233
}

.audit-home{
  overflow: auto;
}
</style>
